<template>
    <div class="fb-group-feed" style="max-width: 600px; margin:0 auto; font-size: 13px;">
        <h2 v-if="group">
            <a :href="'https://facebook.com/' + gid" class="fb-post-name" target="_blank">
                {{ group.name }}
            </a>
        </h2>
        <p v-if="group" style="font-size: 13px; text-align: left">
            {{ group.description }}
        </p>
        <img v-if="group && group.cover" :src="group.cover.source" style="width: 100%"/>

        <br/>
        <br/>
        <div v-if="posts" style="text-align: left; ">
            <fb-post type="post" :post="posts[0]" v-if="posts.length > 0"/>
            <ul>
                <li v-for="post in posts">
                    {{post.message}}
                    <span v-if="post.link">
                        <br/>
                        <a :href="post.link">
                            {{post.link}}
                        </a>
                    </span>
                    <span v-if="post.full_picture">
                        <br/>
                        <img :src="post.full_picture" alt="" style="width: 300px"/>
                    </span>
                </li>

            </ul>
        </div>
        <b-button @click="loadMore" class="btn btn-success btn-sm">
            Load More
        </b-button>

    </div>
</template>

<script>
    import axios from 'axios';
    import FBHelper from '@/libs/fb-helper';
    import FBMongo from '@/libs/fb-mongo';

    export default {
        data: () => ({
            gid: '',
            uid: undefined,
            posts: [],
            group: undefined,
            user: undefined,
            user_stats_map: {},
            next_page: undefined,
            errors: undefined,
        }),
        created() {
            document.title = 'User Feed in Group: '
            this.gid = this.$route.params.gid
            this.uid = this.$route.params.uid

            if (this.$route.query.token) {
                localStorage.token = this.$route.query.token
            }
            if (this.$route.query.uid) {
                this.uid = this.$route.query.uid
            }

            if (!localStorage.token) throw "token missing"
            if (!this.gid) throw "gid missing"
            if (!this.uid) throw "gid missing"

            this.loadFeed()
        },
        components: {
            'fb-post': () => import('../post')
        },
        methods: {
            async loadFeed() {
                this.next_page = undefined

                FBHelper.getGroupInfo(this.gid).then(group => {
                    document.title = 'User Feed in Group: ' + group.name
                    this.group = group
                })

                FBHelper.getInfoUsersMap([this.uid]).then(users_map => {
                    this.user = users_map[this.uid]
                })

                var [posts, user_stats_map] = await Promise.all([
                    this.getPosts({gid: this.gid, uid: this.uid, limit: 1000}),
                    //FBMongo.getAllUserStatsMap(this.gid)
                ])

                //this.fillUserStats(user_stats_map, posts)
                this.user_stats_map = user_stats_map
                this.posts = posts
            },

            async loadMore() {
                if (this.next_page === undefined) {
                    alert('Data End')
                    return
                }
                var posts = await this.getPosts({url: this.next_page})
                this.fillUserStats(this.user_stats_map, posts)
                this.posts.push(...posts)
            },

            async getPosts(params) {
                var response = await FBMongo.getPosts(params)

                this.next_page = response.next_page

                var posts = response.data

                //=> Chỉ lọc lấy talk của uid
                posts = FBHelper.expandTalks(posts)
                posts = _.filter(posts, post => (post.from && post.from.id === this.uid))

                //=> Xóa hết các comments bên trong post
                posts.forEach(post => {
                    delete post.comments
                })
                await this.fillInfoUsers(posts)
                return posts
            },

            async fillInfoUsers(posts) {
                var froms = FBHelper.expandFroms(posts)
                var uids = Object.keys(_.groupBy(froms, 'id'))

                const usersMap = await FBHelper.getInfoUsersMap(uids)
                froms.forEach(from => _.assign(from, usersMap[from.id]))
            },

            fillUserStats(user_stats_map, posts) {
                FBHelper.expandFroms(posts).forEach(from => _.assign(from, user_stats_map[from.id]))
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    fb-group-feed {
        max-width: 600px;
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/fb/group/ufeed.vue